'use strict';

const TimeModel = require('../models/time');
const BaseCollection = require('./base');

class TimesCollection extends BaseCollection {
  initialize() {
    this.model = TimeModel;
  }
}

module.exports = TimesCollection;
